import { api } from "@/lib/apiClient";

export type JobPositionListItem = {
  id: string;
  name: string;
  is_active: boolean;
};

export type JobPositionUpsertIn = {
  name: string;
};

export async function listJobPositions(include_inactive = false) {
  return api.get<JobPositionListItem[]>("/job-positions", {
    params: include_inactive ? { include_inactive: true } : undefined,
  });
}

export async function getJobPosition(id: string) {
  return api.get<JobPositionListItem>(`/job-positions/${id}`);
}

export async function createJobPosition(body: JobPositionUpsertIn) {
  return api.post<JobPositionListItem>("/job-positions", body);
}

export async function updateJobPosition(id: string, body: JobPositionUpsertIn) {
  return api.put<JobPositionListItem>(`/job-positions/${id}`, body);
}

export async function setJobPositionActive(id: string, is_active: boolean) {
  return api.patch<JobPositionListItem>(`/job-positions/${id}/status`, { is_active });
}
